import './MonthFilter.scss';

import { Box } from "@mui/material";

import { Filter } from "../../common-components/Dropdowns/Dropdowns";

const MonthFilter = ({onMonthChange}) => {
    const options = Array.from({ length: 12 }, (_, index) => ({
        id: index.toString(),
        name: new Date(0, index).toLocaleString('ru-RU', { month: 'long' }),
    }));

    const handleOptionClick = (option) => {
        onMonthChange(option.id);
    };

    return (
        <Box className={"month_filter"}>
            <Filter options={options} propertyLabel={"Месяц"} onOptionClick={handleOptionClick}/>
        </Box>
    );
}

export default MonthFilter;